class OptionButtonSelect extends HTMLElement {
  connectedCallback() {
    if (this._on) return;

    this.btn = this.querySelector('.selectlike__trigger');
    this.val = this.querySelector('.selectlike__value');
    this.menu = this.querySelector('.selectlike__menu');
    if (!this.btn || !this.menu) return;

    const close = () => {
      this.classList.remove('is-open');
      this.menu.hidden = true;
      this.btn.setAttribute('aria-expanded', 'false');
    };

    this._toggle = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const open = !this.classList.contains('is-open');
      this.classList.toggle('is-open', open);
      this.menu.hidden = !open;
      this.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    this._pick = (e) => {
      const label = e.target.closest('label');
      if (!label) return;

      const id = label.getAttribute('for');
      const input = id ? this.querySelector(`#${CSS.escape(id)}`) : null;
      if (!input || input.disabled) return;

      if (this.val) {
        this.val.textContent = input.value
      }else {
        this.val.textContent = input.value
      };

      label.click();

      close();
    };

    this._outside = (e) => {
      if (!this.contains(e.target)) close();
    };

    this.btn.addEventListener('click', this._toggle);
    this.menu.addEventListener('click', this._pick);
    document.addEventListener('click', this._outside);

    close();

    this._on = true;
  }

  disconnectedCallback() {
    if (!this._on) return;
    this.btn?.removeEventListener('click', this._toggle);
    this.menu?.removeEventListener('click', this._pick);
    document.removeEventListener('click', this._outside);
    this._on = false;
  }
}

if (!customElements.get('option-button-select')) {
    customElements.define('option-button-select', OptionButtonSelect)
}
